import { Injectable } from '@angular/core';

/**
 * An interface that makes it possible to easily mock time/timeouts in tests.
 * The angular/zone setTimeout mocking with jasmine.clock().install() etc is
 * too unreliable to use.
 */
@Injectable()
export class ClockService {

  constructor() { }

  now(): number {
    return Date.now();
  }

  setTimeout(fn, millis) {
    return setTimeout(fn, millis);
  }

  clearTimeout(handle) {
    return clearTimeout(handle);
  }
}
